import { firstBuyAllImageType } from './functions';

// The senior builder white-screened on a buy-all order because it built sheets
// while imageTypes was still empty (async load race), dereferencing an
// undefined image type. firstBuyAllImageType must return undefined for an empty
// list (so the caller can bail) and never throw on odd data.
describe('firstBuyAllImageType', () => {
  const yearbook = { id: 1, name: 'Yearbook Pose' };
  const download = { id: 2, name: '(1) High-Resolution Downloads' };
  const digital = { id: 3, name: 'Digital File' };

  it('returns undefined for an empty list (the load-race precondition)', () => {
    expect(firstBuyAllImageType([])).toBeUndefined();
  });

  it('returns undefined when imageTypes is null/undefined', () => {
    expect(firstBuyAllImageType(undefined)).toBeUndefined();
    expect(firstBuyAllImageType(null)).toBeUndefined();
  });

  it('prefers the first non-yearbook image type', () => {
    expect(firstBuyAllImageType([yearbook, download, digital])).toBe(download);
  });

  it('falls back to the only type rather than throwing when all are yearbook', () => {
    expect(firstBuyAllImageType([yearbook])).toBe(yearbook);
  });

  it('does not throw when an image type has no name', () => {
    const noName = { id: 9 };
    expect(() => firstBuyAllImageType([noName])).not.toThrow();
    expect(firstBuyAllImageType([noName])).toBe(noName);
  });
});
